import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React, { FC, ReactElement } from 'react';
import { Theme } from 'src/theme';

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
  tableCell: {
    padding: 4
  }
});

type dataAlign = 'left' | 'right' | 'inherit' | 'center' | 'justify';
type headerAlign = 'left' | 'right' | 'inherit' | 'center' | 'justify';

interface BasicTableProps {
  headings?: string[];
  rows?: (string | number | boolean | ReactElement)[][];
  dataAlign?: dataAlign;
  headerAlign?: headerAlign;
  styledHeader?: boolean;
  styledRows?: boolean;
  isCellWidthStatic?: boolean;
  colsWidth?: string[];
 
}
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.text.secondary,
      color: theme.palette.common.black,
    },
  }),
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      }
    },
  }),
)(TableRow);

const BasicTable: FC<BasicTableProps> = ({
  headings = [],
  rows = [],
  dataAlign = 'left',
  headerAlign = 'center',
  isCellWidthStatic = false,
  styledHeader,
  styledRows,
  colsWidth = [],
}) => {
  const classes = useStyles();
  const StyledTableRowWithColors = withStyles((theme: Theme) =>
    createStyles({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: styledRows ? theme.customs.transaction.orange : theme.customs.transaction.lightGreen,
          color: theme.palette.common.black,
        },
        '&:nth-of-type(even)': {
          backgroundColor: styledRows ? theme.customs.transaction.peachOrange : theme.customs.transaction.whisper,
          color: theme.palette.common.black,
        }
      },
    }),
  )(TableRow);
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <colgroup>
          {colsWidth.map((w, i) => (<col key={i} style={{ width: w }} />))}
        </colgroup>
        {headings?.length ? <TableHead>
          <TableRow>
            {headings.map((heading, i) => {
              return (styledHeader
                ? <StyledTableCell key={i} align={i === 0 ? 'left' : headerAlign}>{heading}</StyledTableCell>
                : <TableCell key={i} align={i === 0 ? 'left' : headerAlign}>{heading}</TableCell>);
            })}
          </TableRow>
        </TableHead> : ''}
        {rows?.length ? <TableBody>
          {rows.map((row, k) => {
            return styledHeader ?
              <StyledTableRowWithColors key={k}>
                {Object.keys(row).map((key, i) => {
                  return <TableCell key={i}
                    className={isCellWidthStatic ? classes.tableCell : ''}
                    style={{ color: 'black', verticalAlign: 'top' }}
                    align={i === 0 ? 'left' : dataAlign as dataAlign} component={i === 0 ? 'th' : 'td'}
                    scope={i === 0 ? 'row' : ''
                    }>
                    {row[key]}
                  </TableCell>;
                })}
              </StyledTableRowWithColors>
              :
              <StyledTableRow hover key={k}>
                {Object.keys(row).map((key, i) => {
                  return <TableCell key={i}
                    className={isCellWidthStatic ? classes.tableCell : ''}
                    style={{ verticalAlign: 'top' }}
                    align={i === 0 ? 'left' : dataAlign as dataAlign}
                    component={i === 0 ? 'th' : 'td'}
                    scope={i === 0 ? 'row' : ''
                    }>
                    {row[key]}
                  </TableCell>;
                })}
              </StyledTableRow>;

          })}
        </TableBody> : ''}
      </Table>
    </TableContainer >
  );
};

export default BasicTable;
